export default __webpack_public_path__ + "static/media/leave.914dbece.svg";